import type { PersonById } from '../../../../services/personApi';
import { maskDocument } from '../../credit-analysis/utils/documentUtils';
import type { Party } from '../../../../types/LegalCase';

// Rótulo de uma parte do caso, em um lugar só. A regra anti-duplicação (ADR 001) faz a parte com
// `personId` **não** guardar nome local — o nome vive no `person` e é resolvido na leitura. Toda
// tela que mostra parte precisa tratar os dois casos, então a regra não fica duplicada: a lista de
// partes e o seletor de pagador do lançamento manual leem daqui.

// Nome exibido: parte externa usa o nome local; parte com personId usa o nome resolvido do
// person (ou um placeholder enquanto resolve / se o person não responder).
export const displayPartyName = (party: Party, resolved?: PersonById): string => {
    if (party.name) return party.name;
    if (resolved?.name) return resolved.name;
    if (party.personId) return 'Cadastrado em Pessoas';
    return '—';
};

// Documento exibido: local (contraparte externa) ou o resolvido do person, com máscara.
export const displayPartyDocument = (party: Party, resolved?: PersonById): string | null => {
    const doc = party.document || resolved?.document || null;
    return doc ? maskDocument(doc) : null;
};
